import { buildApiUrl, toMockErrorResponse, toMockResponse } from 'fake-db/apiConfig'
import Mock from '../../mock'
import shortid from 'shortid'
import axios from 'axios.js'

// const CategoryList = {
//     category:[
//         {id:1,name:"Сеты",active:true,podCategory:false,edit:true},
//         {id:2,name:"Роллы",active:true,podCategory:false,edit:true},
//         {id:3,name:"Суши",active:true,podCategory:false,edit:true},
//         {id:4,name:"Пицца",active:true,podCategory:false,edit:true},
//         {id:5,name:"Лапша",active:true,podCategory:false,edit:true},
//         {id:6,name:"Супы",active:true,podCategory:false,edit:true},
//         {id:7,name:"Салаты",active:true,podCategory:false,edit:true},
//         {id:8,name:"Закуски",active:true,podCategory:false,edit:true},
//         {id:9,name:"Напитки",active:true,podCategory:false,edit:true},
//         {id:10,name:"Горячие закуски",active:true,podCategory:false,edit:true},
//     ]
// };

const CategoryList = {
    category:[]
};

export default CategoryList;



const getAllCategoryUser = async ()=>{
    const response = await axios.get(buildApiUrl('catalog/getAllCategory/'));

    const {error, errorInfo, result, message, data } = response.data;
    const AllCategoryUser = data;

    console.log('[catalog][category] raw server response', response.data);
    if (error || result === 'error') {
        console.warn('[catalog][category] server returned error', { error, errorInfo, message, result });
        return {
            __error: true,
            error: error || 'Error Billing Feature',
            errorInfo: errorInfo || message || 'Ошибка загрузки категорий',
            result: result || 'error',
        };
    }
    console.log('[catalog][category] parsed list', Array.isArray(AllCategoryUser) ? AllCategoryUser : []);


    return AllCategoryUser;
};


const setActiveCategory = async (id,val)=>{
    const response = await axios.post(buildApiUrl('catalog/setCategoryActive/'),{
        id,
        val
    });

    const {error, errorInfo, result, message, data } = response.data;
    const AllCategoryUser = data;

    // console.log('Сервер вернул данные по обновлению статуса Category  - ',response);


    return AllCategoryUser;
};



const setDeletedCategory = async (id,val)=>{
    const response = await axios.post(buildApiUrl('catalog/setCategoryDeleted/'),{
        id,
        val
    });

    const {error, errorInfo, result, message, data } = response.data;
    const AllCategoryUser = data;

    // console.log('Сервер вернул данные по обновлению статуса Category  - ',response);


    return AllCategoryUser;
};




const setUpdateCategory = async (dataCategoryUpdate)=>{
    const response = await axios.post(buildApiUrl('catalog/setCategoryUpdate/'),{
        dataCategoryUpdate
    });

    const {error, errorInfo, result, message, data } = response.data;
    const AllCategoryUser = data;

    console.log('Сервер вернул данные по обновлению статуса Category  -++++++++++++++++++ ',dataCategoryUpdate,response);


    return AllCategoryUser;
};
const setUpdateCategorySortable = async (dataCategoryUpdateSortable)=>{
    const response = await axios.post(buildApiUrl('catalog/setCategoryUpdateSortable/'),{
        dataCategoryUpdateSortable
    });

    const {error, errorInfo, result, message, data } = response.data;
    const AllCategoryUser = data;

    console.log('Сервер вернул данные по обновлению статуса Category  -++++++++++++++++++ ',dataCategoryUpdateSortable,response);


    return AllCategoryUser;
};


const setSaveNewCategory = async (dataCategoryUpdate)=>{
    const response = await axios.post(buildApiUrl('catalog/setSaveNewCategory/'),{
        dataCategoryUpdate
    });
    const {error, errorInfo, result, message, data } = response.data;
    const AllCategoryUser = data;

    console.log('Сервер вернул данные по обновлению статуса Category  - ',response, dataCategoryUpdate);


    return AllCategoryUser;
};

const generateCategoryProductArticles = async (payload = {}) => axios.post(
    buildApiUrl('catalog/generateCategoryProductArticles/'),
    {
        category_id: Number(payload?.category_id) || 0,
        mode: payload?.mode === 'overwrite' ? 'overwrite' : 'fill_empty',
    },
    { headers: { 'Content-Type': 'multipart/form-data' } }
)

Mock.onGet('/api/catalog/getAllCategory').reply(async (config) => {
    // const response = await NotificationDB.list
    // return [200, response]

    const AllCategoryUser = await getAllCategoryUser();
    // console.log('С сервера пришло - ', AllCategoryUser);

    // if (!AllCategoryUser) {
    //     return [400, { message: 'Список цветов отсутствует!' }]
    // }


    if (AllCategoryUser && AllCategoryUser.__error) {
        console.warn('[catalog][mock][category] reply 400', AllCategoryUser);
        return [400, AllCategoryUser]
    }

    if (!AllCategoryUser) {
        console.log('[catalog][mock][category] reply 200 empty (falsy payload)');
        return [200, [] ]
    }

    // const accessToken = user.accessToken;

    return [
        200,
        AllCategoryUser,
    ]


})


Mock.onPost('/api/catalog/setActiveCategory').reply(async (config) => {
    // const response = await NotificationDB.list
    // return [200, response]

    let { id } = JSON.parse(config.data);
    let { val } = JSON.parse(config.data);
    // console.log('Данные для отправки на сервер ',id, val, config.data);

    const AllCategoryUser = await setActiveCategory(id,val);

    // if (!AllCategoryUser) {
    //     return [400, { message: 'Список пометок отсутствует!' }]
    // }


    if (!AllCategoryUser) {
        return [200, []]
    }

    // const accessToken = user.accessToken;

    return [
        200,
        AllCategoryUser,
    ]


})

Mock.onPost('/api/catalog/setDeletedCategory').reply(async (config) => {
    // const response = await NotificationDB.list
    // return [200, response]

    let { id } = JSON.parse(config.data);
    let { val } = JSON.parse(config.data);
    // console.log('Данные для отправки на сервер ',id, val, config.data);

    const AllCategoryUser = await setDeletedCategory(id,val);

    // if (!AllCategoryUser) {
    //     return [400, { message: 'Список пометок отсутствует!' }]
    // }


    if (!AllCategoryUser) {
        return [200, []]
    }

    // const accessToken = user.accessToken;

    return [
        200,
        AllCategoryUser,
    ]


})


Mock.onPost('/api/catalog/setUpdateCategory').reply(async (config) => {
    // const response = await NotificationDB.list
    // return [200, response]

    let { dataCategoryUpdate } = JSON.parse(config.data);
    // console.log('Данные для отправки на сервер ', config.data);

    const Category = await setUpdateCategory(dataCategoryUpdate);

    // console.log('Серовер вернул данные ',AllCategoryUser);

    // if (!Category) {
    //     return [400, { message: 'Список пометок отсутствует!' }]
    // }

    if (!Category) {
        return [200, []]
    }

    // const accessToken = user.accessToken;

    return [
        200,
        Category,
    ]


})

Mock.onPost('/api/catalog/generateCategoryProductArticles').reply(async (config) => {
    let payload = {};
    try {
        payload = typeof config?.data === 'string' ? JSON.parse(config.data || '{}') : (config?.data || {});
        const response = await generateCategoryProductArticles(payload);
        return toMockResponse(response);
    } catch (error) {
        console.error('[catalog][category] article generation error', error);
        return toMockErrorResponse(error, 'Ошибка массовой генерации артикулов');
    }
})

Mock.onPost('/api/catalog/setUpdateCategorySortable').reply(async (config) => {
    // const response = await NotificationDB.list
    // return [200, response]

    let { dataCategoryUpdateSortable } = JSON.parse(config.data);
    // console.log('Данные для отправки на сервер ', config.data);

    const Category = await setUpdateCategorySortable(dataCategoryUpdateSortable);

    // console.log('Серовер вернул данные ',AllCategoryUser);

    // if (!Category) {
    //     return [400, { message: 'Список пометок отсутствует!' }]
    // }

    if (!Category) {
        return [200, []]
    }

    // const accessToken = user.accessToken;

    return [
        200,
        Category,
    ]


})


Mock.onPost('/api/catalog/setSaveNewCategory').reply(async (config) => {
    // const response = await NotificationDB.list
    // return [200, response]

    let { dataCategoryUpdate } = JSON.parse(config.data);
    // console.log('Данные для отправки на сервер ', config.data);

    const Category = await setSaveNewCategory(dataCategoryUpdate);

    // console.log('Серовер вернул данные ',AllCategoryUser);

    // if (!Category) {
    //     return [400, { message: 'Список пометок отсутствует!' }]
    // }

    if (!Category) {
        return [200, []]
    }

    // const accessToken = user.accessToken;

    return [
        200,
        Category,
    ]
})
